import { render, staticRenderFns } from "./ProductCardLoading.vue?vue&type=template&id=59e56bad&scoped=true&"
import script from "./ProductCardLoading.vue?vue&type=script&lang=js&"
export * from "./ProductCardLoading.vue?vue&type=script&lang=js&"
import style0 from "./ProductCardLoading.vue?vue&type=style&index=0&id=59e56bad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e56bad",
  null
  
)

export default component.exports